import React from "react";

import Typography from "../../components/Typography";

import { ReactComponent as CloseIcon } from "../../build/images/icons/Close-2.svg";
import { ReactComponent as WarningIcon } from "../../build/images/icons/warning-tag.svg";
import { ReactComponent as ErrorIcon } from "../../build/images/icons/error-tag.svg";

import "./filter-tag.css";

export default function FilterTag({
  label,
  onClose,
  profile = false,
  amount,
  amountLabel,
  type,
  priority,
  agent,
  alertIcon = false,
  onClickAlert,
  channelIcon = false,
}) {
  return (
    <div
      className="filter-tag"
      style={{ alignItems: "center", marginBottom: "4px" }}
    >
      {alertIcon &&
        (alertIcon === "warning" ? (
          <WarningIcon
            onClick={onClickAlert}
            className="filter-tag__alertIcon"
          />
        ) : (
          <ErrorIcon onClick={onClickAlert} className="filter-tag__alertIcon" />
        ))}
      {amount ? (
        <div className="filter-tag__amount">
          <Typography.H6 color="primary-dark" weight="bold">
            {amount}&nbsp;
          </Typography.H6>
          <Typography.H6 color="primary-dark">{amountLabel}</Typography.H6>
        </div>
      ) : (
        <>
          <Typography.H5
            color="blue-selected-4"
            weight={500}
            className="filter-tag__label"
          >
            {channelIcon && channelIcon}&nbsp;
            {label}
          </Typography.H5>
        </>
      )}

      {onClose && (
        <CloseIcon onClick={onClose} className="filter-tag__btn-close" />
      )}
    </div>
  );
}
